import * as React from 'react';
import { Autocomplete, Box, Card, CardActionArea, CardMedia, Divider, Grid, TextField, Typography } from '@mui/material';
import { ButtonBrand, gold, TypographyBrand, white } from '../../../../../getLPTheme';
import { useParams } from 'react-router-dom';

export default function Category({items}) {

    const params = useParams();

    const handleCategory = () => {
        if (params.cid === 'club') {
            return 'Clubes de Golf'
        } else if (params.cid === 'hotel') {
            return 'Hoteles'
        } else if (params.cid === 'comercio') {
            return 'Comercios'
        } else if (params.cid === 'turismo') {
            return 'Turismo'
        } else if (params.cid === 'torneo') {
            return 'Torneos'
        } else if (params.cid === 'hotel') {
            return 'Hoteles'
        }
        else {
            return 'Otros Beneficios'
        }
    }

    let arrayModel = []

    items.map(row => arrayModel.push(row.country));
    let countrys = Array.from(new Set(arrayModel))

    arrayModel = []

    items.map(row => arrayModel.push(row.state));
    let states = Array.from(new Set(arrayModel))

    arrayModel = []
    
    items.map(row => arrayModel.push(row.locate));
    let locates = Array.from(new Set(arrayModel))
    arrayModel = []


    const [itemsFilter, setItemsFilter] = React.useState(items);

    const [filterData, setFilterData] = React.useState({
        country: '',
        state: '',
        locate: '',
    });

    React.useEffect(() => {
        handleCheck();
      }, [filterData])

    const handleCheck = () => {
        if ((filterData.country == undefined || filterData.country == '') && (filterData.state == undefined || filterData.state == '') && (filterData.locate == undefined || filterData.locate == '')) {
            setItemsFilter((items))
        }
        else if ((filterData.state == undefined || filterData.state == '') && (filterData.locate == undefined || filterData.locate == '')) {
            let itemsArray = items.filter((row) => row.country === filterData.country)
            setItemsFilter((itemsArray))
        }
        else if ((filterData.country == undefined || filterData.country == '') && (filterData.locate == undefined || filterData.locate == '')) {
            let itemsArray = items.filter((row) => row.state === filterData.state)
            setItemsFilter((itemsArray))
        }
        else if ((filterData.country == undefined || filterData.country == '') && (filterData.state == undefined || filterData.state == '')) {
            let itemsArray = items.filter((row) => row.locate === filterData.locate)
            setItemsFilter((itemsArray))
        }
        else if (filterData.country == undefined || filterData.country == '') {
            let itemsArray = items.filter((row) => row.state === filterData.state && row.locate === filterData.locate)
            setItemsFilter((itemsArray))
        }
        else if (filterData.locate == undefined || filterData.locate == '') {
            let itemsArray = items.filter((row) => row.country === filterData.country && row.state === filterData.state)
            setItemsFilter((itemsArray))
        }
        else if (filterData.state == undefined || filterData.state == '') {
            let itemsArray = items.filter((row) => row.country === filterData.country && row.locate === filterData.locate)
            setItemsFilter((itemsArray))
        } else {
            let itemsArray = items.filter((row) => row.country === filterData.country && row.state === filterData.state && row.locate === filterData.locate)
            setItemsFilter((itemsArray))
        }
    };



    const handleInputChangeCountry = (e,value) => {
        setFilterData({ ...filterData, ['country']: value }); 
    };
    
    const handleInputChangeState = (e,value) => {
        setFilterData({ ...filterData, ['state']: value }); handleCheck();
    };

    const handleInputChangeLocate = (e,value) => {
        setFilterData({ ...filterData, ['locate']: value }); handleCheck();
    };


    return (
        <Box sx={{mt:10}}>
            <TypographyBrand sx={{fontSize: {xl: "2vw", lg: "2vw", md: "2vw", sm:"2vw", xs:"4vw"}}}>
                Categoría: {handleCategory()}
            </TypographyBrand>
            {/* Pantallas Grandes */}
            <Box sx={{display: {xl: 'flex', lg: 'flex', md: 'flex', sm:'flex', xs:'none'}, justifyContent: 'center', alignItems: 'center', direction: 'row'}}>
                <Box sx={{width: '100%',pb:2}}>
                    <Grid container direction="row" justifyContent="center" alignItems="center">
                        <Grid item xs={1}>
                            <Typography sx={{fontSize: '1.5vw'}}>
                                País
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Autocomplete onInputChange={handleInputChangeCountry} options={countrys} renderInput={(parametros) => 
                                <TextField {...parametros} InputLabelProps={{ shrink: false }} size="small" label='' required margin="dense" placeholder='Seleccione País' name="typeMarker" sx={{width: 220, pr:1,color: white[50], '& .MuiOutlinedInput-root': { "&.Mui-focused fieldset":{borderColor: white[50]}, boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50],'&:hover': {borderColor: gold[500], color: white[50]}}}}/>}
                            />
                        </Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={1}>
                            <Typography sx={{fontSize: '1.5vw'}}>
                                Provincia
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Autocomplete onInputChange={handleInputChangeState} options={states} renderInput={(parametros) => 
                                <TextField {...parametros} InputLabelProps={{ shrink: false }} size="small" label='' required margin="dense" placeholder='Seleccione Provincia' name="typeMarker" sx={{width: 220, pr:1,color: white[50], '& .MuiOutlinedInput-root': { "&.Mui-focused fieldset":{borderColor: white[50]}, boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50],'&:hover': {borderColor: gold[500], color: white[50]}}}}/>}
                            />
                        </Grid>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={1}>
                            <Typography sx={{fontSize: '1.5vw'}}>
                                Localidad
                            </Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Autocomplete onInputChange={handleInputChangeLocate} options={locates} renderInput={(parametros) => 
                                <TextField {...parametros} InputLabelProps={{ shrink: false }} size="small" label='' required margin="dense" placeholder='Seleccione Localidad' name="typeMarker" sx={{width: 220, pr:1,color: white[50], '& .MuiOutlinedInput-root': { "&.Mui-focused fieldset":{borderColor: white[50]}, boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50],'&:hover': {borderColor: gold[500], color: white[50]}}}}/>}
                            />
                        </Grid>
                    </Grid>

                    <Box sx={{p:2}}>
                        <Grid container direction="row" justifyContent="center" alignItems="center">
                            {itemsFilter.map((row) => (
                                <Grid item xs={4}>
                                    <Box sx={{ position: 'relative', pt:2, display: 'flex', direction:"row", justifyContent:"center", alignItems:"center"}}>
                                        <Box sx={{}}>
                                            <Card sx={{width: {xs: 310, sm: 440}, p:1, m:1, transition: "0.2s","&:hover": {transform: "scale(1.02)",},}}>
                                                <CardActionArea href={`/categoria/${params.cid}/${row.pointId}`} >
                                                    <CardMedia component="img" image={row.image} height="400" alt="Card Image" sx={{opacity: 0.5}}/>
                                                    <Box sx={{position: 'absolute',top: "0%",height: 400, left: 0,width: '100%',color: 'white',padding: '5px',direction:"column", justifyContent:"center", alignItems:"flex-start", display: "grid"}}>
                                                        <TypographyBrand sx={{m:1,fontSize: {xl: "2vw", lg: "2vw", md: "2vw", sm:"2vw", xs:"4vw"}}}>
                                                            {row.name} <br/> {row.locate}
                                                        </TypographyBrand>
                                                    </Box>
                                                </CardActionArea>
                                            </Card>
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Box>
                <Divider/>
            </Box>


            {/* Pantallas Chicas */}
            <Box sx={{display: {xl: 'none', lg: 'none', md: 'none', sm:'none', xs:'flex'}, justifyContent: 'center', alignItems: 'center', direction: 'row'}}>
                <Box sx={{width: '100%',pb:2}}>
                    <Grid container direction="row" justifyContent="center" alignItems="center" width={'60%'}>
                        {/* <Grid item xs={4}>
                            <Typography sx={{fontSize: '4vw', ml:1, mr: 1}}>
                                País
                            </Typography>
                        </Grid> */}
                        <Grid item xs={8}>
                            <Autocomplete onInputChange={handleInputChangeCountry} options={countrys} renderInput={(parametros) => 
                                <TextField {...parametros} InputLabelProps={{ shrink: false }} label='' margin="dense" placeholder='Seleccione País' name="typeMarker" sx={{ pr:1,color: white[50], '& .MuiOutlinedInput-root': { "&.Mui-focused fieldset":{borderColor: white[50]}, boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50],'&:hover': {borderColor: gold[500], color: white[50]}}}}/>}
                            />
                        </Grid>
{/* 
                        <Grid item xs={4}>
                            <Typography sx={{fontSize: '4vw', ml:1, mr: 1}}>
                                Provincia
                            </Typography>
                        </Grid> */}
                        <Grid item xs={8}>
                            <Autocomplete onInputChange={handleInputChangeState} options={states} renderInput={(parametros) => 
                                <TextField {...parametros} InputLabelProps={{ shrink: false }} size="small" label='' margin="dense" placeholder='Seleccione Provincia' name="typeMarker" sx={{ pr:1,color: white[50], '& .MuiOutlinedInput-root': { "&.Mui-focused fieldset":{borderColor: white[50]}, boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50],'&:hover': {borderColor: gold[500], color: white[50]}}}}/>}
                            />
                        </Grid>

                        {/* <Grid item xs={4}>
                            <Typography sx={{fontSize: '4vw', ml:1, mr: 1}}>
                                Localidad
                            </Typography>
                        </Grid> */}
                        <Grid item xs={8}>
                            <Autocomplete onInputChange={handleInputChangeLocate} options={locates} renderInput={(parametros) => 
                                <TextField {...parametros} InputLabelProps={{ shrink: false }} size="small" label='' margin="dense" placeholder='Seleccione Localidad' name="typeMarker" sx={{ pr:1,color: white[50], '& .MuiOutlinedInput-root': { "&.Mui-focused fieldset":{borderColor: white[50]}, boxSizing: 'border-box',borderRadius: '0px',border: '1px solid',borderColor: white[50], color: white[50],'&:hover': {borderColor: gold[500], color: white[50]}}}}/>}
                            />
                        </Grid>
                    </Grid>

                    <Box sx={{p:2}}>
                        <Grid container direction="row" justifyContent="center" alignItems="center">
                            {itemsFilter.map((row) => (
                                <Grid item xs={12}>
                                    <Box sx={{ position: 'relative', pt:2, display: 'flex', direction:"row", justifyContent:"center", alignItems:"center"}}>
                                        <Box sx={{}}>
                                            <Card sx={{width: {xs: 310, sm: 440}, p:1, m:1, transition: "0.2s","&:hover": {transform: "scale(1.02)",},}}>
                                                <CardActionArea href={`/categoria/${params.cid}/${row.pointId}`} >
                                                    <CardMedia component="img" image={row.image} height="400" alt="Card Image" sx={{opacity: 0.5}}/>
                                                    <Box sx={{position: 'absolute',top: "0%",height: 400, left: 0,width: '100%',color: 'white',padding: '5px',direction:"column", justifyContent:"center", alignItems:"flex-start", display: "grid"}}>
                                                        <TypographyBrand sx={{m:1,fontSize: {xl: "2vw", lg: "2vw", md: "2vw", sm:"2vw", xs:"4vw"}}}>
                                                            {row.name} <br/> {row.locate}
                                                        </TypographyBrand>
                                                    </Box>
                                                </CardActionArea>
                                            </Card>
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </Box>
                <Divider/>
            </Box>
        </Box>
    ) 
}